import React from 'react';

import useClassy from '@core/hooks/useClassy';
import { useSuperHubStore } from '@core/store';

import Spinner from '@ui/Spinner';

import classes from './style.module.scss';

/**
 * Renders a loading state for SuperHub routes as a fallback
 * for when the route component's module is being loaded asynchronously.
 */
export default function RouteLoadingFallback() {
  const bem = useClassy(classes, 'RouteLoadingFallback');
  const layout = useSuperHubStore(s => s.layout);

  return layout === 'default' ? (
    // Default loading state for hub "view" routes
    // using the legacy scss spinner mixin
    <div className={bem('&', '_default')} />
  ) : (
    // Loading state for superhub admin routes
    // using the Spinner component
    <div className={bem('&', `_${layout}`)}>
      <Spinner size="lg" />
    </div>
  );
}
